import { getStaticAsset } from '@/utils/staticAsset';
import { useEffect, useRef } from 'react';
import { StyledCanvas } from './styles';

function loadCoinImage(src: string) {
  return new Promise((resolve) => {
    const image = new Image();
    image.src = src;
    image.onload = () => resolve(image);
  });
}

interface CoinItem {
  x: number;
  y: number;
  dy: number;
  s: number; //大小随机
  state: number; //状态随机
}

export interface CoinConfigType {
  vY: number; //speed
  // vSize: number; //size
  vState: number; //state
  aY: number; //acc
  countPercent: number;
}

export const defaultCoinConfig: CoinConfigType = {
  vY: 6,
  // vSize: 1,
  vState: 0.2,
  aY: 0.6,
  countPercent: 1,
};

export default function CoinCanvas({
  vY = defaultCoinConfig.vY,
  vState = defaultCoinConfig.vState,
  aY = defaultCoinConfig.aY,
  countPercent = defaultCoinConfig.countPercent,
} = {}) {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    const coins: CoinItem[] = [];
    const CORN_WIDTH = 44;
    const CORN_HEIGHT = 40;
    let coinImg: HTMLImageElement;
    const ax = Number(aY); //加速度
    //init canvas style
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;

    loadCoinImage(getStaticAsset('/assets/images/casino/coin.png')).then(
      (image) => {
        coinImg = image as HTMLImageElement;
        drawLoop();
      },
    );

    const drawLoop = () => {
      requestAnimationFrame(drawLoop);
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      if (Math.random() < Number(countPercent)) {
        // 让中间多一些，边缘少一些，所以取平均值
        const x1 = (Math.random() * canvas.width) | 0;
        const x2 = (Math.random() * canvas.width) | 0;
        // const x= (x1 + x2) / 2;
        const x = x1;
        coins.push({
          x,
          y: -50,
          dy: vY,
          s: 0.5 + Math.random(),
          state: (Math.random() * 10) | 0,
        });
      }
      let i = coins.length;
      while (i--) {
        const { x, y, s, state } = coins[i];
        coins[i].state = state > 9 ? 0 : state + Number(vState);
        coins[i].dy += Number(ax);
        coins[i].y += coins[i].dy;
        //drawImage(image, sx, sy, sWidth, sHeight, dx, dy, dWidth, dHeight)
        ctx.drawImage(
          coinImg,
          CORN_WIDTH * Math.floor(state),
          0,
          CORN_WIDTH,
          CORN_HEIGHT,
          x,
          y,
          CORN_WIDTH * s,
          CORN_HEIGHT * s,
        );

        if (y > canvas.height) {
          coins.splice(i, 1);
        }
      }
    };
  }, []);

  return (
    <StyledCanvas
      ref={canvasRef}
      style={{ position: 'fixed', top: 0, left: 0, zIndex: 999 }}
    ></StyledCanvas>
  );
}
